<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-orange">Agentes</h3>
              <hr />
            </div>
            <div class="col-lg-12 text-end mb-3">
              <button v-on:click="$modal.show('modal_add')" class="btn btn-orange btn-lg rounded-pill">
                <i class="bx bxs-plus-circle"></i> Nuevo agente
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12"></div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="mt-3 mb-3">
                  <label>Buscar</label>
                  <div class="input-group mb-3 shadow border">
                    <span class="input-group-text" id="basic-addon1"><strong><i class="bx bx-search-alt"></i></strong>
                    </span>
                    <input v-on:keyup="get_agentes" v-model="search" type="text" class="form-control"
                      placeholder="Buscar agente..." aria-label="Username" aria-describedby="basic-addon1" />
                  </div>
                </div>
                <div v-if="loading_usuarios" class="text-center">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div v-else>
                  <transition appear name="slide-fade">
                    <div v-if="usuarios.length != 0">
                      <div class="mt-2 mb-3 text-end">
                        <button v-on:click="download" class="btn btn-success rounded-pill">
                          <i class="bx bx-download"></i> Descargar
                        </button>
                      </div>
                      <div class="table-responsive">
                        <table class="table table-bordered table-condensed table-hover">
                          <thead>
                            <tr>
                              <th style="width: 5%">#</th>
                              <th style="width: 25%">Nombre</th>
                              <th style="width: 5%">Perfil</th>
                              <th style="width: 30%">Email</th>
                              <th style="width: 13%">WhatsApp</th>
                              <th class="text-center" style="width: 12%">
                                Opciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(usuario, index_usuario) in usuarios" v-bind:key="index_usuario">
                              <td>{{ index_usuario + 1 }}</td>
                              <td class="text-uppercase">
                                {{ usuario.nombre_completo }}
                                <div v-if="usuario.estado == 2" class="text-warning">
                                  <small> Inactivo </small>
                                </div>
                              </td>
                              <td>
                                <span v-if="usuario.perfil == 0">Admin</span>
                                <span v-if="usuario.perfil == 1">Agente</span>
                                <span v-if="usuario.perfil == 2">Diseñador</span>
                                <span v-if="usuario.perfil == 3">Agencia de Marketing</span>
                                <span v-if="usuario.perfil == 4">Editorial</span>
                              </td>
                              <td>
                                {{ usuario.email }}
                              </td>
                              <td>{{ usuario.whatsapp }}</td>
                              <td class="text-center">
                                <button v-on:click="
                                  (index_select = index_usuario),
                                  $modal.show('modal_edit')
                                " class="btn btn-sm btn-primary">
                                  <i class="bx bx-edit"></i>
                                </button>
                                <button v-on:click="
                                  (index_select = index_usuario),
                                  $modal.show('modal_key')
                                " class="btn btn-sm btn-orange">
                                  <i class="bx bx-key"></i>
                                </button>
                                <button v-on:click="
                                  (index_select = index_usuario),
                                  $modal.show('modal_eliminar')
                                " class="btn btn-sm btn-danger">
                                  <i class="bx bx-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <modal name="modal_add" :adaptive="true" height="550">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Nuevo agente</h4>
        </div>
        <div class="card-body">
          <div v-if="pass == null">
            <div class="form-group">
              <label>Perfil</label>
              <select v-model="nuevo.perfil" class="form-control">
                <option value="0">Admin</option>
                <option value="1">Agente</option>
                <option value="2">Diseñador</option>
                <option value="3">Agencia de Marketing</option>
                <option value="4">Editorial</option>
              </select>
            </div>
            <div class="form-group">
              <label>Nombres</label>
              <input v-model="nuevo.nombres" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>Apellidos</label>
              <input v-model="nuevo.apellidos" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input v-model="nuevo.email" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>WhatsApp</label>
              <input v-model="nuevo.whatsapp" type="text" class="form-control" />
            </div>
            <hr />
            <div class="text-end">
              <button v-on:click="set_agente" class="btn btn-success rounded-pill">
                <i class="bx bx-save"></i> Guardar
              </button>
              <button v-on:click="$modal.hide('modal_add')" class="btn btn-outline-secondary rounded-pill ms-1">
                Cancelar
              </button>
            </div>
          </div>
          <div v-else>
            <div class="alert alert-info">
              <li>Usuario: {{ user }}</li>
              <li>Clave: {{ pass }}</li>
            </div>
            <div class="text-end">
              <button v-on:click="pass = null" class="btn btn-orange rounded-pill ms-1">
                Crear nuevo usuario
              </button>
              <button v-on:click="$modal.hide('modal_add')" class="btn btn-outline-secondary rounded-pill ms-1">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_edit" :adaptive="true" height="610">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Editar agente</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null">
            <div class="form-group">
              <label>Perfil</label>
              <select v-model="usuarios[index_select].perfil" class="form-control">
                <option value="0">Admin</option>
                <option value="1">Agente</option>
                <option value="2">Diseñador</option>
                <option value="3">Agencia de Marketing</option>
                <option value="4">Editorial</option>
              </select>
            </div>
            <div class="form-group">
              <label>Nombres</label>
              <input v-model="usuarios[index_select].nombres" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>Apellidos</label>
              <input v-model="usuarios[index_select].apellidos" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input v-model="usuarios[index_select].email" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>WhatsApp</label>
              <input v-model="usuarios[index_select].whatsapp" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <label>Estado</label>
              <select v-model="usuarios[index_select].estado" class="form-control">
                <option value="1">Activo</option>
                <option value="2">Inactivo</option>
              </select>
            </div>
            <hr />
            <div class="text-end">
              <button v-on:click="update_agente" class="btn btn-success rounded-pill">
                <i class="bx bx-save"></i> Guardar
              </button>
              <button v-on:click="$modal.hide('modal_edit')" class="btn btn-outline-secondary rounded-pill ms-1">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_key" :adaptive="true" height="240">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Restablecer contraseña</h4>
        </div>
        <div class="card-body">
          <div v-if="pass == null">
            <div v-if="index_select != null">
              <div>
                ¿Deseas restablecer la contraseña de
                <strong> {{ usuarios[index_select].nombre_completo }}</strong>
              </div>

              <hr />
              <div class="text-end">
                <button v-on:click="update_password" class="btn btn-success rounded-pill">
                  Sí
                </button>
                <button v-on:click="$modal.hide('modal_key')" class="btn btn-outline-secondary rounded-pill ms-1">
                  No
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="alert alert-info">
              <li>Nueva clave: {{ pass }}</li>
            </div>
            <div class="text-end">
              <button v-on:click="$modal.hide('modal_key')" class="btn btn-outline-secondary rounded-pill ms-1">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_eliminar" :adaptive="true" height="250">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-danger">Eliminar Agente</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null" class="text-danger">
            ¿Desea eliminar al agente
            <strong>{{ usuarios[index_select].nombre_completo }}</strong>?
          </div>
          <hr />
          <div class="text-end">
            <button @click="eliminar" class="btn btn-danger rounded-pill">
              Sí
            </button>
            <button @click="$modal.hide('modal_eliminar')" class="btn btn-outline-secondary rounded-pill">
              No
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import { AdminService } from '../../services/AdminService';
export default {
  name: "Usuarios",
  metaInfo: {
    title: "Usuarios - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      loading_usuarios: true,
      page: 1,
      search: null,
      usuarios: [],
      vista: 1,
      paginate: null,
      index_select: null,
      nuevo: {
        nombres: null,
        apellidos: null,
        email: null,
        whatsapp: null,
      },
      user: null,
      pass: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    if (this.session.usuario.perfil != 0) {
      this.$notify({
        type: "error",
        group: "foo",
        title: "Ups!",
        text: "Acceso denegado",
      });
      this.$router.push("/");
    }
    this.page = this.$route.params.page;
    this.get_agentes();
  },
  methods: {
    get_agentes: function () {
      this.loading_usuarios = true;
      var search = null;
      if (this.search != null && this.search.trim().length != 0) {
        search = this.search;
      }
      var params = {
        page: this.page,
        search: search,
      };
      AdminService.getUsuarios(this.session.token, params)
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuarios = response.data.data.usuarios;
          this.get_paginate(response.data.data.total_pages);
          this.loading_usuarios = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/agentes/1' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/agentes/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/agentes/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/agentes/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/agentes/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/agentes/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/agentes/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/agentes/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    set_agente: function () {
      var re = /\S+@\S+\.\S+/;
      var valida_email = re.test(this.nuevo.email);

      if (!valida_email) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita una dirección de correo electrónico válida.",
        });
        return false;
      }
      this.loading = true;
      this.user = null;
      this.pass = null;
      const vm = this;
      var params = {
        usuario: this.nuevo,
      };
      AdminService.setAdmin(this.session.token, params)
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          } else {
            vm.nuevo = {
              nombres: null,
              apellidos: null,
              email: null,
              whatsapp: null,
            };
            vm.user = response.data.user;
            vm.pass = response.data.pass;
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Bien!",
              text: response.data.message,
            });
            vm.get_agentes();
            vm.loading_usuarios = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    update_agente: function () {
      var re = /\S+@\S+\.\S+/;
      var valida_email = re.test(this.usuarios[this.index_select].email);

      if (!valida_email) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita una dirección de correo electrónico válida.",
        });
        return false;
      }
      this.loading_usuarios = false;
      this.user = null;
      this.pass = null;
      const vm = this;
      var params = {
        usuario: this.usuarios[this.index_select],
      };
      AdminService.UpdateAdmin(this.session.token, params)
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading_usuarios = false;
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Bien!",
              text: response.data.message,
            });
            vm.get_agentes();
            vm.$modal.hide("modal_edit");
            vm.loading_usuarios = false;
          }

          vm.loading_usuarios = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading_usuarios = false)
        )
        .finally();
    },
    update_password: function () {
      this.loading_usuarios = false;
      this.user = null;
      this.pass = null;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario: this.usuarios[this.index_select].id_usuario,
      };
      axios
        .post(this.$base_url + "admin/update_password", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            vm.loading_usuarios = false;
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Bien!",
              text: response.data.message,
            });
            vm.get_agentes();
            vm.pass = response.data.pass;
            vm.loading_usuarios = false;
          }
          vm.loading_usuarios = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading_usuarios = false)
        )
        .finally();
    },
    eliminar: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario_admin: this.usuarios[this.index_select].id_usuario,
      };
      axios
        .post(this.$base_url + "admin/eliminar_usuario_admin", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Eliminado!",
              text: response.data.message,
            });
          }
          vm.index_select = null;
          vm.$modal.hide("modal_eliminar");
          vm.get_agentes();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    download: function () {
      window.open(
        this.$base_url + "download/agentes/" + this.session.token,
        "_blank"
      );
    },
  },
  mounted: function () {
    this.loading = false;
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_usuarios();
    },
  },
};
</script>